import { useFlags } from 'launchdarkly-react-client-sdk';

import { BOOKING_COMPLETED_SEGMENT } from 'shared/consts/paths';

/** The segment a finished checkout navigates to, as each completion site spells it today. */
export const RECEIPT_SEGMENT = 'receipt';

/**
 * RES-1407 — the ONE switch every completion site reads to decide where a finished checkout goes.
 *
 * Flag off: `receipt`, exactly as before, so each site's navigation is byte-for-byte unchanged. Flag on:
 * `booked`, the route that decides between the add-on offer and My bookings and never mounts the old
 * receipt (`BookingCompleted`). Kept as a segment, not a path, because every site builds its own path
 * by rewriting the one it stands on (`quick-checkout` → …, `checkout` → …, `redirect` → …).
 */
export const useBookingCompletionSegment = (): string => {
  const { enable2WayChatRedesignResourceBooking } = useFlags();

  return enable2WayChatRedesignResourceBooking ? BOOKING_COMPLETED_SEGMENT : RECEIPT_SEGMENT;
};
